<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/network.jpg')"
      >
      </parallax>
      <div class="content-center">
        <div class="container">
          <div style="text-align: center;">
              <div style="display: inline-block; text-align: left;">
                  <h1 class="title">Build on <br>what's happening.</h1>
              </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">

    </div> <!-- end: row -->

    <div class="section section-about-us">
      <div class="container">

      <div class="row">
        <div class="col-md-8 ml-auto mr-auto">
          <h2 class="title">Events API & Dashboard</h2>

          <div>

            The Crowdify Events API and Dashboard provide information about local events. Our Users can: <br>
            <ul style="margin-left: 0em; padding-left: 3em; padding-top:0.5em">
              <li>Retrieve events within a defined radius around a city</li>
              <li>Determine which events are happening when</li>
              <li>Get additional information about events like event category, predicted amount of participants, ...</li>
            </ul>
          </div>

          <h3 class="title">Scope</h3>
          <div>
            Crowdify offers events for the following cities:
            <ul style="margin-left: 0em; padding-left: 3em; padding-top:0.5em">
              <li>Berlin</li>
              <li>Düsseldorf</li>
              <li>Frankfurt</li>
              <li>Hamburg</li>
              <li>Köln</li>
              <li>München</li>
              <li>Stuttgart</li>
              <li>more to come soon ...</li>
            </ul>
            Crowdify provides the following information from an event:
            <ul style="margin-left: 0em; padding-left: 3em; padding-top:0.5em">
              <li>Title</li>
              <li>Start</li>
              <li>End (predicted)</li>
              <li>Category (see below)</li>
              <li>Location</li>
              <li>State</li>
              <li>Predicted participants (optionally)</li>
            </ul>
              The following categories are supported:
              <ul style="margin-left: 0em; padding-left: 3em; padding-top:0.5em">
                <li>Fair</li>
                <li>Concert</li>
                <li>Musical</li>
                <li>Performing Arts</li>
                <li>Humor</li>
                <li>Football</li>
                <li>Handball</li>
              </ul>
            </div>

            <h3 class="title">How To Get Started</h3>
            <div>
              To use the Crowdify Events API and Dashboard just get in touch with us at <a href="mailto:team@crowdify.io?subject=Customer Onboarding">team@crowdify.io</a>.
              We are more than happy to onboard you and your team within a day.
              We will create a company account for you with a corresponding client_id and client_secret. This information can be used to query the Crowdify Events API.
              Please find more information on API Access
              <router-link v-popover:popover1 to="/documentation/api/start">
                here
              </router-link>.
            </div>


            <h4 class="title">Dashboard Access</h4>
            <div>
              If you want to use the Crowdify Dasboard as well, your team members can easily self-register their own personal account <router-link v-popover:popover1 to="/auth">
                here
              </router-link>. The registration is enabled for onboarded companies.
              Since security is one of our main values it is very important for us that your company account is only accessible for persons that you know. Just let us know who belongs to you and we will make sure that nobody else will use your account and the corresponding quota.
            </div>

            <h4 class="title">Rate Limits</h4>
            <div>
              API calls and Dashboard queries are rate limited at the company-account-level. We will gladly advise you on the possible options.
            </div>



            <h3 class="title">Product Documentation</h3>
            <div class="row">
                <div class="col-sm" style="background-color:#386576; color:white">
                  <div class="border-text">
                    <h2 class="title">
                      Events API
                    </h2>
                    <img style="max-height:300px" src="img/response.png">

                    <div class="text-center" style = "padding-top:30px; padding-bottom:30px;">
                      <v-btn
                        rounded
                        color="rgba(255, 255, 255, 0.7)"
                        dark
                        to="/documentation/api/start"
                      >
                        Documentation
                      </v-btn>
                    </div>

                  </div>
                </div>
                <div class="col-sm" style="background-color:#C6D3DF; ">
                  <div class="border-text">
                    <h2 class="title">
                      Dashboard
                    </h2>
                    <img style="max-height:300px; text-align:center" src="img/CrowdifyDashboard.png">
                    <div class="text-center" style = "padding-top:30px; padding-bottom:30px;">
                      <v-btn
                        rounded
                        color="rgba(255, 255, 255, 0.7)"
                        to="/documentation/dashboard/start"
                      >
                        Documentation
                      </v-btn>
                    </div>
                  </div>
                </div>

              </div><!--end: row for products -->
              <div style="padding-top:40px">
                <div style="font-size:2em; font-weight: 900; color:#C51162">Ready to build your solution?</div>
                <div style="font-size:3em; font-weight: 900;">Just get in touch with us</div>

              </div>

              <div style="padding-top:40px">




                <div class="container">

                <v-form
                  ref="form"
                  v-model="valid"
                >
                  <div class="row">
                    <div class="col"><v-text-field v-model="form.first_name" label="First Name" :rules="[v => !!v || 'First Name is required']"></v-text-field></div>
                    <div class="col"><v-text-field v-model="form.last_name" label="Last Name" :rules="[v => !!v || 'First Name is required']"></v-text-field></div>
                  </div>
                  <div class="row">
                    <div class="col"><v-text-field v-model="form.e_mail" label="E-Mail" :rules="emailRules" required></v-text-field></div>
                    <div class="col"><v-text-field v-model="form.phone" label="Phone"></v-text-field></div>
                  </div>
                  <div class="row">
                    <div class="col"><v-text-field v-model="form.company" label="Company"></v-text-field></div>
                    <div class="col"><v-text-field v-model="form.position" label="Position"></v-text-field></div>
                  </div>
                  <div class="row">
                    <div class="col"><v-text-field v-model="form.use_case" label="What Use Cases Are You Considering?"></v-text-field></div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <v-textarea
                        name="input-7-1"
                        label="Message"
                        v-model="form.message"
                        :rules="[v => !!v || 'Text is required']"
                        required
                      ></v-textarea>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col"><v-checkbox :rules="[v => !!v || 'Consent is required']" class="ml-3" v-model="form.contact_consent_given" label=" I agree with the processing and storage of personal data for the needs of direct marketing" value=""></v-checkbox></div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <v-btn
                        rounded
                        color="rgba(255, 255, 255, 0.7)"
                        v-on:click="submitContactForm"
                        :disabled="!valid"
                      >
                        Submit
                      </v-btn>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                    <v-card
                      height="50"
                      flat
                    >
                      <v-snackbar
                        :timeout="3000"
                        :value="true"
                        absolute
                        left
                        shaped
                        top
                        color="#72efdd"
                        v-model="mail_snackbar"
                      >
                        Thank you, we will get back to you.
                      </v-snackbar>
                    </v-card>

                    </div>
                  </div>
                  </v-form>

                </div>
              </div>



            </div><!--end: table bootstrap -->
        </div>
      </div>
    </div>




  </div>
</template>
<script>

import { Auth } from 'aws-amplify'

import { Button, FormGroupInput } from '@/components';
import EventsApi from '@/services/api/Events'

export default {
  name: 'Landing',
  bodyClass: 'landing-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {
      form: {
        first_name: '',
        e_mail: '',
        message: '',
        company: '',
        phone: '',
        use_case: '',
        position: '',
        contact_consent_given: ''
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      valid: true,
      mail_snackbar: false,
    };
  },
  methods: {
    validate () {
      this.$refs.form.validate()
    },
    submitContactForm: function (event) {
      this.$refs.form.validate();
      var mailForm = {
          "type":"contactForm",
          "sender":{
              "first_name":this.form.first_name,
              "last_name":this.form.last_name,
              "e_mail":this.form.e_mail,
              "phone":this.form.phone,
              "company":this.form.company,
              "position":this.form.position
          },
          "details":{
              "use_case":this.form.use_case,
              "text": this.form.message
          }
      };



      //convert object to json string
      var string = JSON.stringify(mailForm);
      EventsApi.sendMail(string).then((results) => {
          // access results here by chaining to the returned promise

          if(results.status==200){
            this.mail_snackbar=true;
          }else{
          }


      });


      this.form.first_name = '',
      this.form.last_name = '',
      this.form.e_mail = '',
      this.form.phone = '',
      this.form.message = '',
      this.form.use_case = '',
      this.form.position = '',
      this.form.company = '',
      this.form.contact_consent_given = '',
      this.$refs.form.resetValidation();

    },


  }
};
</script>
<style>

.metadata {
    font-size: 1.2em;
    font-weight: 700;
    margin-bottom: 15px;
}

</style>
